import { combineReducers } from '@reduxjs/toolkit'
import userReducer, { userLogout } from './slices/userSlice'
import ticketReducer from './slices/ticketsSlice'
import commnentReducer from './slices/commentSlice'
import snackReducer from './slices/snackSlice'
import notificationsReducer from './slices/notificationSlice'
import LoadingReducer from './slices/loadingSlice'
import discountReducer from './slices/discountSlice'
import usersReducer from './slices/usersSlice'
import customersReducer from './slices/customersSlice'
import commonReducer from './slices/commonSlice'
import refGroupReducer from './slices/refereeGroupsSlice'
import scholarshipReducer from './slices/scholarshipSlice'
import packageSliceReducer from './slices/packageSlice'
import examSliceReducer from './slices/examSlice'
import salesReducer from './slices/salesSlice'
import courseSliceReducer from './slices/courseSlice'
import DashboardSliceReducer from './slices/dashboardSlice'
import eventSliceReducer from './slices/eventSlice'

const appReducer = combineReducers({
  user: userReducer,
  tickets: ticketReducer,
  comments: commnentReducer,
  snack: snackReducer,
  notifications: notificationsReducer,
  loading: LoadingReducer,
  discounts: discountReducer,
  users: usersReducer,
  customers: customersReducer,
  common: commonReducer,
  refereeGroups: refGroupReducer,
  scholarship: scholarshipReducer,
  package: packageSliceReducer,
  sales: salesReducer,
  exam: examSliceReducer,
  course: courseSliceReducer,
  dashboard: DashboardSliceReducer,
  event: eventSliceReducer,
})

const rootReducer = (state, action) => {
  if (action.type === userLogout.type) state = undefined
  return appReducer(state, action)
}

export default rootReducer
